import { render, staticRenderFns } from "./StrategyDetails.vue?vue&type=template&id=63dabade&"
import script from "./StrategyDetails.vue?vue&type=script&lang=js&"
export * from "./StrategyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports